module.exports = __webpack_public_path__ + "onboarding-variable.6b6556332ba32736d1558e5e3c83800c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/projects/empty/onboarding-variable.svg
// module id = 3155945276166867
// module chunks = 1